import { useContext } from 'react';
import { I18nextContext } from 'gatsby-plugin-react-i18next';
import { DEFAULT_LOCALE } from '@constants';
import locales from '../../i18n.js';

// Locales and nodes are passed as parameters
const useLanguageData = (nodes: { lang: string }[]) => {
  const languageContext = useContext(I18nextContext);
  const currentLocale = locales.find((locale: { path: string }) => locale.path === languageContext.language);

  // Function to find a single node for the current language
  const findNodeByLanguage = (lang: string) => {
    return nodes?.find((node) => node.lang === lang);
  };

  // Function to filter nodes by the current locale or default locale
  const filterNodesByCurrentLanguage = () => {
    const defaultLocaleNodes = nodes.filter((node) => node.lang === DEFAULT_LOCALE);
    const localeNodes = nodes.filter((node) => node.lang === currentLocale?.locale);

    return localeNodes.length ? localeNodes : defaultLocaleNodes;
  };

  // Get page data for the current locale or fall back to default locale (English GB) if not available
  const pageData = findNodeByLanguage(currentLocale?.locale ?? 'en-gb') || findNodeByLanguage(DEFAULT_LOCALE);

  return {
    pageData, // The specific page data based on language
    findNodeByLanguage, // Function to find node by language
    filterNodesByLanguage: filterNodesByCurrentLanguage // Function to filter nodes by language
  };
};

export default useLanguageData;
